import React from 'react'

const Footer = () => {
  return (
    <div className="text-center py-3 text-muted" style={{
      fontSize: '0.85rem',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.95)'
    }}>
      Powered by <a href="https://byscott.io" target="_blank" rel="noopener noreferrer" className="text-muted">IdeasByScott.com</a>
    </div>
  )
}

export default Footer
